import * as React from "react";
import {
  Show,
  SimpleShowLayout,
  TextField,
 
} from "react-admin";

const BadgeShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="badgeName" />
      <TextField source="badgeDescription" />
    </SimpleShowLayout>
  </Show>
);

export default BadgeShow;
